var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("recurring-reminders", {
    ref: "recurringReminders",
    attrs: {
      "application-notification-frequency":
        _vm.APPLICATION_NOTIFICATION_FREQUENCY,
    },
    on: { "allow-save": _vm.handleAllowSave, submit: _vm.handleSubmit },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }